import { render } from "./HomeView.vue?vue&type=template&id=a7061c14&scoped=true&ts=true"
import script from "./HomeView.vue?vue&type=script&lang=ts"
export * from "./HomeView.vue?vue&type=script&lang=ts"

import "./HomeView.vue?vue&type=style&index=0&id=a7061c14&scoped=true&lang=css"

import exportComponent from "D:\\Clouds\\Programacion\\Vue\\reyes-magos\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7061c14"]])

export default __exports__